import "core-js/modules/es.array.map.js";
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import CustomFieldHolder from "./CustomFieldHolder";
import AsyncButton from "../core/button/AsyncButton/AsyncButton";
import classNames from "../../util/classNames";
import { _ActionsWrapper, _ButtonWrapper, _CustomFieldsWrapper } from "./style";
var CustomFields = function CustomFields(_ref) {
  var applicationId = _ref.applicationId,
    className = _ref.className,
    customFieldDefinitions = _ref.customFieldDefinitions,
    customFields = _ref.customFields,
    hasPermission = _ref.hasPermission,
    id = _ref.id,
    inContentSection = _ref.inContentSection,
    onInsertField = _ref.onInsertField,
    onRemoveField = _ref.onRemoveField,
    studentId = _ref.studentId;
  return /*#__PURE__*/React.createElement(_CustomFieldsWrapper, {
    id: id,
    className: classNames('custom-fields', className)
  }, /*#__PURE__*/React.createElement("div", null, customFields.map(function (data) {
    return /*#__PURE__*/React.createElement(CustomFieldHolder, {
      applicationId: applicationId,
      attributes: data,
      className: "custom-field-".concat(data.id),
      customFieldDefinitions: customFieldDefinitions,
      hasPermission: hasPermission,
      inContentSection: inContentSection,
      key: "new-field-".concat(data.id),
      onRemoveField: onRemoveField,
      studentId: studentId
    });
  })), !inContentSection && /*#__PURE__*/React.createElement(_ActionsWrapper, {
    className: "actions"
  }, customFieldDefinitions && /*#__PURE__*/React.createElement(_ButtonWrapper, null, /*#__PURE__*/React.createElement(AsyncButton, {
    buttonColor: "black",
    buttonHover: "hoverGrey",
    disabled: !hasPermission('create_custom_field'),
    onClick: hasPermission('create_custom_field') ? onInsertField : null
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "plus"
  })))));
};
CustomFields.propTypes = {
  applicationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  customFieldDefinitions: PropTypes.array,
  customFields: PropTypes.array,
  id: PropTypes.string,
  onInsertField: PropTypes.func,
  onRemoveField: PropTypes.func,
  studentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default CustomFields;